module.exports = __webpack_public_path__ + "static/media/twit.d37dab55.svg";